let showAlertHandler = null;

export const registerAlertHandler = (fn) => {
  showAlertHandler = fn;
};

export const showMyAlert = (config) => {
  if (!showAlertHandler) {
    console.warn("GlobalAlert not mounted yet");
    return;
  }

  // Allow showAlert("message") shorthand
  if (typeof config === "string") {
    showAlertHandler({ message: config, type: "info" });
  } else {
    showAlertHandler(config);
  }
};
